const inMemory = {};

const getItem = (key) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

const setItem = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

const cachedFetch = async <T>(url: string, cacheTime: number, skipCache?: boolean): Promise<T> => {
  const key = `FETCHED:${url}`;
  if (!skipCache) {
    if (inMemory[key]) return inMemory[key];

    const { fetchedAt, data } = getItem(key) || {};
    if (data && fetchedAt > Date.now() - cacheTime) return data;
  }

  const res = await fetch(url);
  if (!res.ok) {
    console.error(`cachedFetch:${url}`, res);
    const text = await res.text();
    throw new Error(text);
  }

  const json = await res.json();
  if (!skipCache) {
    if (!cacheTime) {
      inMemory[key] = json;
    } else {
      setItem(key, { fetchedAt: Date.now(), data: json });
    }
  }

  return json;
};

export default cachedFetch;
